if (!customElements.get('nussmart-gift-nutrition')) {
  customElements.define(
    'nussmart-gift-nutrition',
    class NussmartGiftNutrition extends HTMLElement {
      connectedCallback() {
        const productInfo = this.closest('product-info');
        productInfo?.classList.add('nussmart-gift-product');

        const pickerGroups = productInfo?.querySelectorAll('.product-form__input--pill');
        pickerGroups?.[0]?.classList.add('nm-gift-picker--content');
        pickerGroups?.[1]?.classList.add('nm-gift-picker--greeting');

        if (this.variantChangeUnsubscriber) return;

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!data?.html) return;
          if (this.dataset.sectionId && data.sectionId && this.dataset.sectionId !== data.sectionId) return;

          const source = data.html.getElementById(this.id);
          if (!source) return;

          const ingredientsWasOpen =
            this.querySelector('[data-nm-gift-panel="ingredients"]')?.open === true;
          const nutritionWasOpen = this.querySelector('.accordion--nutrition details')?.open === true;

          this.innerHTML = source.innerHTML;
          this.dataset.variantId = data.variant?.id || source.dataset.variantId || '';

          if (source.dataset.sourceProductId) {
            this.dataset.sourceProductId = source.dataset.sourceProductId;
          } else {
            delete this.dataset.sourceProductId;
          }

          if (ingredientsWasOpen) {
            this.querySelector('[data-nm-gift-panel="ingredients"]')?.setAttribute('open', '');
          }

          if (nutritionWasOpen) {
            this.querySelector('.accordion--nutrition details')?.setAttribute('open', '');
          }
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
        this.variantChangeUnsubscriber = undefined;
      }
    }
  );
}
